import React, { useState } from 'react';
import './FAQ.css';

const FAQ = ({ items = [], title = 'FAQ', id = 'faq' }) => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  if (!items.length) return null;

  return (
    <section className="faq-section" id={id} aria-labelledby={`faq-title-${id}`}>
      <div className="faq-inner">
        <h2 id={`faq-title-${id}`} className="faq-title">
          {title}
        </h2>
        <div className="faq-list" role="list">
          {items.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <article
                key={index}
                className={`faq-item ${isOpen ? 'faq-item--open' : ''}`}
                role="listitem"
              >
                <button
                  type="button"
                  className="faq-question"
                  onClick={() => toggle(index)}
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${id}-${index}`}
                  id={`faq-question-${id}-${index}`}
                >
                  <span className="faq-question-num">{index + 1}</span>
                  <span className="faq-question-text">{item.question}</span>
                  <span className="faq-icon" aria-hidden="true">
                    {isOpen ? (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M18 15l-6-6-6 6" />
                      </svg>
                    ) : (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M6 9l6 6 6-6" />
                      </svg>
                    )}
                  </span>
                </button>
                <div
                  id={`faq-answer-${id}-${index}`}
                  className="faq-answer"
                  role="region"
                  aria-labelledby={`faq-question-${id}-${index}`}
                  aria-hidden={!isOpen}
                >
                  <div className="faq-answer-inner">
                    <p className="faq-answer-text">{item.answer}</p>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
